import React from 'react';
import { Instagram, Twitter, Facebook, Youtube, Mail } from 'lucide-react';
import { footerLinks } from '../mock';
import { YDD_LOGO } from './Navbar';

const Footer = () => {
  const socials = [Instagram, Twitter, Facebook, Youtube];
  return (
    <footer className="bg-[#0B0B0E] border-t border-white/8 pt-16 pb-8">
      <div className="container-ydd">
        <div className="grid md:grid-cols-2 lg:grid-cols-5 gap-10">
          <div className="lg:col-span-2">
            <img
              src={YDD_LOGO}
              alt="YDD.News — Your Daily Dose"
              className="h-16 w-auto object-contain"
              style={{ mixBlendMode: 'lighten' }}
            />
            <p className="text-gray-400 mt-5 max-w-sm leading-relaxed">India's rewarding news app. Read bite-sized news daily, earn points, and redeem exclusive discounts from top brands.</p>
            <a href="mailto:contact@yourdailydose.news" className="inline-flex items-center gap-2 text-gray-300 hover:text-[var(--ydd-yellow)] transition-colors mt-5 text-sm">
              <Mail size={16} /> contact@yourdailydose.news
            </a>
            <div className="flex items-center gap-3 mt-6">
              {socials.map((Icon, i) => (
                <a key={i} href="#" className="h-9 w-9 rounded-full border border-white/12 flex items-center justify-center text-gray-300 hover:border-[var(--ydd-yellow)] hover:text-[var(--ydd-yellow)] transition-colors duration-200">
                  <Icon size={16} />
                </a>
              ))}
            </div>
          </div>
          {Object.entries(footerLinks).map(([heading, links]) => (
            <div key={heading}>
              <h4 className="text-white font-semibold text-sm">{heading}</h4>
              <ul className="mt-4 space-y-3">
                {links.map((l) => (
                  <li key={l}>
                    <a href="#" className="text-gray-400 text-sm hover:text-[var(--ydd-yellow)] transition-colors">{l}</a>
                  </li>
                ))}
              </ul>
            </div>
          ))}
        </div>
        <div className="mt-14 pt-6 border-t border-white/8 flex flex-col sm:flex-row items-center justify-between gap-3">
          <p className="text-gray-500 text-sm">© {new Date().getFullYear()} YourDailyDose.News. All rights reserved.</p>
          <p className="text-gray-600 text-xs">Made in India • Read · Earn · Save</p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
